"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subject = void 0;
const Deferred_1 = require("./Deferred");
class Subject {
    constructor(options = {}) {
        this.doneValue = {
            done: true,
            value: {},
        };
        this.queue = [];
        this.deferreds = [];
        this.done = false;
        this.noMoreResults = false;
        this.backPressureDeferred = new Deferred_1.Deferred();
        this.finallyCallbacks = [];
        this.error = undefined;
        this.maxQueueLength = undefined;
        this.maxQueueLength = options.maxQueueLength;
        this.iterator = {
            throw: (e) => {
                this.done = true;
                this.finallyCallbacks.map(cb => cb());
                for (const deferred of this.deferreds) {
                    deferred.reject(e);
                }
                return Promise.reject(e);
            },
            return: (_value) => {
                this.done = true;
                this.finallyCallbacks.map(cb => cb());
                for (const deferred of this.deferreds) {
                    deferred.resolve({
                        done: true,
                        value: {},
                    });
                }
                return Promise.resolve(this.doneValue);
            },
            next: (_value) => {
                if (this.error) {
                    return Promise.reject(this.error);
                }
                const queuedItem = this.queue.shift();
                if (this.queue.length === 0) {
                    this.backPressureDeferred.resolve();
                    this.backPressureDeferred = new Deferred_1.Deferred();
                }
                if (queuedItem !== undefined) {
                    return Promise.resolve(queuedItem);
                }
                else {
                    if (this.noMoreResults && !this.done) {
                        this.done = true;
                        this.finallyCallbacks.map(cb => cb());
                    }
                    if (this.done) {
                        return Promise.resolve({
                            done: true,
                            value: {},
                        });
                    }
                    const deferred = new Deferred_1.Deferred();
                    this.deferreds.push(deferred);
                    return deferred.promise;
                }
            },
            [Symbol.asyncIterator]() {
                return this;
            },
        };
    }
    finally(callback) {
        this.finallyCallbacks.push(callback);
    }
    onCompleted() {
        return this.callback({ done: true, value: {} });
    }
    onNext(value) {
        return this.callback({ done: false, value });
    }
    onError(error) {
        this.error = error;
        for (const queuedDeferred of this.deferreds) {
            queuedDeferred.reject(error);
        }
        this.noMoreResults = true;
    }
    isDone() {
        return this.done;
    }
    callback(result) {
        if (!(this && this instanceof Subject)) {
            const errorMessage = 'This must be a Subject. Have you bound this?';
            throw new Error(errorMessage);
        }
        if (result.done) {
            for (const queuedDeferred of this.deferreds) {
                queuedDeferred.resolve(result);
            }
            this.noMoreResults = true;
            return Promise.resolve();
        }
        const deferred = this.deferreds.pop();
        if (deferred !== undefined) {
            deferred.resolve(result);
            return Promise.resolve();
        }
        else {
            this.queue.push(result);
            if (this.maxQueueLength !== undefined && this.queue.length > this.maxQueueLength) {
                if (process.env.NODE_ENV === 'developement' || process.env.NODE_ENV === 'test') {
                    console.warn([
                        `Subject queue length exceeds specified ${this.maxQueueLength} (was ${this.queue.length}).`,
                        `There might be a memory leak in your application, not calling .return() on generators from .watch() you don't consume anymore.`,
                        `The socket will limit the queue to ${this.maxQueueLength} and you will lose data.`,
                    ].join(' '));
                }
                this.queue.splice(0, this.queue.length - this.maxQueueLength);
            }
            return this.backPressureDeferred.promise;
        }
    }
}
exports.Subject = Subject;
//# sourceMappingURL=Subject.js.map